module.exports = __webpack_public_path__ + "static/media/fogg-page-not-found-1.ffadd160.png";